import React from 'react';
import * as XLSX from 'xlsx';
import axios from 'axios';
import { Button } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import formatSampleFile from '../resources/format_sample.xlsx';
import { saveAs } from 'file-saver';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ExcelUploadPage = () => {
  const history = useHistory();

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    const fileReader = new FileReader();

    fileReader.onload = async function (e) {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });

      const allCompaniesSet = new Set(); // To store all unique company names across all years
      const parsedData = {}; // To store the final processed data

      workbook.SheetNames.forEach((sheetName) => {
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet);

        jsonData.forEach((row) => {
          const year = parseInt(sheetName);
          const companyName = row.companyName;
          const placements = parseInt(row.placements);
          const totalStudentsAppeared = parseInt(row.Total_Students_Appeared);
          const lastLineText = row.lastLineText || null; // Set lastlinetext as null if there is no value

          allCompaniesSet.add(companyName); // Add the company name to the set

          if (!parsedData[year]) {
            parsedData[year] = {}; // Initialize the year object if it doesn't exist
          }

          parsedData[year][companyName] = {
            placements,
            totalStudentsAppeared,
            HighestPkg: row.HighestPkg,
            AvgPkg: row.AvgPkg,
            lastLineText, // Add the lastlinetext to the object
          };
        });
      });

      // Add all unique companies to each year with placements and totalStudentsAppeared as 0 if not already present
      const allCompaniesArray = Array.from(allCompaniesSet);
      Object.keys(parsedData).forEach((year) => {
        const yearData = parsedData[year];
        allCompaniesArray.forEach((companyName) => {
          if (!yearData[companyName]) {
            yearData[companyName] = {
              placements: 0,
              totalStudentsAppeared: 0,
              HighestPkg: null,
              AvgPkg: null,
              lastLineText: null, // Set lastlinetext as null for missing companies
            };
          }
        });
      });

      // Convert the parsedData object to an array
      const finalParsedData = [];
      Object.keys(parsedData).forEach((year) => {
        const yearData = parsedData[year];
        Object.keys(yearData).forEach((companyName) => {
          finalParsedData.push({
            year: parseInt(year),
            companyName,
            placements: yearData[companyName].placements,
            Total_Students_Appeared: yearData[companyName].totalStudentsAppeared,
            HighestPkg: yearData[companyName].HighestPkg,
            AvgPkg: yearData[companyName].AvgPkg,
            lastLineText: yearData[companyName].lastLineText, // Add lastlinetext to the array
          });
        });
      });

      // Save finalParsedData to a JSON file
      const jsonContent = JSON.stringify(finalParsedData, null, 2);
      console.log(finalParsedData);
      console.log(jsonContent);
      //const blob = new Blob([jsonContent], { type: 'application/json' });
      //const jsonFile = new File([blob], 'graphdata.json');

      // Create download link
      //const downloadURL = URL.createObjectURL(jsonFile);
      //setDownloadLink(downloadURL);

      // Delete existing file from GitHub
      await deleteFile();

      // Commit JSON file to GitHub using the GitHub API
      const commitMessage = 'Upload graphdata.json';
      await commitFile(jsonContent, commitMessage);

      console.log('File committed to GitHub');
    };

    fileReader.readAsArrayBuffer(file);
  };

  const deleteFile = async () => {
    const apiUrl = 'https://api.github.com/repos/LeoC1992/graph/contents/src/graphdata.json';
    const authToken = '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';

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      const sha = response.data.sha;
      const deleteMessage = 'Delete graphdata.json';

      await axios.delete(apiUrl, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
        data: {
          message: deleteMessage,
          sha: sha,
        },
      });

      console.log('File deleted from GitHub');
      toast.success('Existing Data removed.');
    } catch (error) {
      console.error('Failed to delete the file:', error.response.data);
      toast.error('Failed to remove data. Please contact system Administrator.');
    }
  };

  const commitFile = async (content, commitMessage) => {
    const apiUrl = 'https://api.github.com/repos/LeoC1992/graph/contents/src/graphdata.json';
    const authToken = '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';

    try {
      const response = await axios.put(apiUrl, {
        message: commitMessage,
        content: btoa(content),
      }, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      console.log('File committed to GitHub:', response.data);
      toast.success('Data has been Updated. Please allow 10 minutes to reflect');
    } catch (error) {
      console.error('Data not updated please contact system Administrator', error.response.data);
    }
  };

  const handleLogout = () => {
    // Clear the logged-in status in localStorage
    localStorage.removeItem('isLoggedIn');

    // Redirect to the login page
    history.push('/login');
  };

  const handleDownloadSampleExcel = () => {
    saveAs(formatSampleFile, 'format_sample.xlsx');
  };

  return (
    <div className="d-flex align-items-center justify-content-center vh-100">
      <div className="text-center">
        <h1 className="mb-4">Upload your Data in Excel Format</h1>
        <input type="file" accept=".xlsx, .xls" onChange={handleFileChange} className="form-control mb-3" />
        <div className="mb-2">
          <Button variant="primary" onClick={handleDownloadSampleExcel} className="mb-2">
            Download Sample Excel
          </Button>
        </div>
        <div>
          <Button variant="danger" onClick={handleLogout}>
            Logout
          </Button>
        </div>
      </div>
      <ToastContainer /> {/* Add ToastContainer component */}
    </div>
  );
};

export default ExcelUploadPage;
